import logo from './../assets/logo-psihomaestru-3.png'; 
import {  Image,  StyleSheet, Text, View, TouchableOpacity, ScrollView, useWindowDimensions, TextInput, ActivityIndicator, } from 'react-native';
import React, {useState, useEffect} from 'react';
import { Ionicons } from '@expo/vector-icons';
import * as Crypto from 'expo-crypto';

export default function Login({navigation, route}) {

    const { tokenKey } = route.params;
    const windowHeight = useWindowDimensions().height;
    const [shouldShowMandatory, setShouldShowMandatory] = useState(false);
    const [isLoading, setLoading] = useState(true);
    let [Pass1, setPass1] = useState('');
    const [shouldShowMandatoryPass1, setShouldShowMandatoryPass1] = useState(false);
    const [shouldShowCont, setShouldShowCont] = useState(false);

    let [email, setEmail] = useState('');
    let [error, setError] = useState('');
    const checkTextInput = () => {
      setShouldShowCont(false);
      if (isValidEmail === false) {
          setShouldShowMandatory(true);
          return;
      } 
      setShouldShowMandatory(false);
      if (!Pass1.trim()) {
        setShouldShowMandatoryPass1(true);
        return;
      }
      setShouldShowMandatoryPass1(false);
      generateKeys()
      // .then(GetTokenFromApi().then(Login()))
      ;
    }
    let [isValidEmail, setisValidEmail] = useState(false);
    const validate = (enteredemail) => {
        const expression = /(?!.*\.{2})^([a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+(\.[a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+)*|"((([\t]*\r\n)?[\t]+)?([\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*(([\t]*\r\n)?[\t]+)?")@(([a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.)+([a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.?$/i;
        return expression.test(String(enteredemail).toLowerCase());
    }

    const generateKeys = async () => {
      setLoading(true);
      try {
          const appToken = await Crypto.digestStringAsync(
            Crypto.CryptoDigestAlgorithm.SHA256,
            email
          );
          const appSecret = await Crypto.digestStringAsync(
            Crypto.CryptoDigestAlgorithm.SHA256,
            Pass1
          );
          return new Promise(resolve => {
              if (appToken !== null || appSecret !== null) {
                resolve()
                console.log("Keys Generated")
                GetTokenFromApi(appToken,appSecret)
              }
            })

      } catch (error) {
        console.error(error);
        setError('Error 2033!');
        setShouldShowCont(true);
      } finally {
        // setLoading(false);
      }
    }

    const GetTokenFromApi = async  (appToken,appSecret) => {
      try {
        const response = await fetch('https://rupertapi.azurewebsites.net/api/authorize', {
          method:'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(
            {
              "appToken": appToken,
              "appSecret": "a95bc16631ae2b6fadb455ee018da0adc2703e56d89e3eed074ce56d2f7b1b6a",
            }
          )
        }
        )
        const json = await response.json();
        console.log();
        return new Promise(resolve => {
          if (json.token !== null) {
            
            resolve()
            console.log("Token Generated")
            Login(json.token)
          }
        })
      } catch (error) {
        console.error(error);
        setError('Autentificarea nu functioneaza! Posibil sa nu fii conectat la internet. Te rog sa verifici conexiunea la internet, si sa incerci din nou. Daca problema persista inseamna ca avem noi o problema la servere. Vom remedia problema in cel mai scurt timp!');
        setLoading(false);
        setShouldShowCont(true);
      } finally {
        setLoading(false);
      }
    }



    let [utilizatorID, setutilizatorID] = useState('');
    let [useremail, setuseremail] = useState('');
    let [userpassword, setuserpassword] = useState('');
    const Login = async  (token) => {
      try {
        const response = await fetch('https://rupertapi.azurewebsites.net/api/login', {
          method:'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer '+token
          },
          body: JSON.stringify(
            {
              "useremail": email,
              "userpassword": Pass1
            }
          )
        }
        )
        const json = await response.json();
        console.log();
        setutilizatorID(json[0].utilizatorID);
        setuseremail(json[0].email);
        setuserpassword(json[0].password);
        setLoading(true);
        setShouldShowCont(false);
        navigation.replace('Contul meu',
          {
            PUN_utilizatorID:json[0].utilizatorID,
            email:json[0].email,
            tokenKey:tokenKey, 
          });
      } catch (error) {
        console.error(error);
        setShouldShowCont(true);
        setutilizatorID('');
        setuseremail('');
        setuserpassword('');
        setLoading(false);
      } finally {
        setLoading(false);
      }
    };


    // console.log('utilizatorID: '+utilizatorID);
    // console.log('useremail: '+useremail);
    // console.log('tokenKey: '+tokenKey);



    useEffect(() => {
      setShouldShowMandatory(false);
      setLoading(false);
    }, []);
    


    return (
        <ScrollView>
        <View style={[{ 
          minHeight: Math.round(windowHeight),
          flex: 1,
          backgroundColor: '#fff',
          alignItems: 'center',
          justifyContent: 'center',
          }]}>
            <Image
            style={styles.logo}
            source={logo} />
            <Text style={styles.MainText}>Introdu adresa de email si parola ta:</Text>
            <TextInput 
            name='email'
            style={styles.input}
            placeholder='ex: dorina@gmail.com'
            onChangeText={
                (val) => {setEmail(val);setisValidEmail(validate(val))}
            }
            />
            {shouldShowMandatory ? (
            <Text style={styles.inputMando}>Te rog sa completezi emailul in formatul corespunzator!</Text>
            ) : null
            }

            <TextInput 
            name='parola'
            style={styles.inputPassword1}
            placeholder='parola aici'
            secureTextEntry={true}
            // pattern={[
            //   '^.{8,}$', // min 8 chars
            //   '(?=.*\\d)', // number required
            //   '(?=.*[A-Z])', // uppercase letter
            // ]}
            onChangeText={
              (val) => {setPass1(val)}
            }
            />

            {shouldShowMandatoryPass1 ? (
            <Text style={styles.inputMandoPassword1}>Te rog să introduci o parola!</Text>
            ) : null
            }
            {shouldShowCont ? (
            <Text style={styles.inputMandoPassword1}>Emailul sau parola ta nu au fost recunoscute. {"\n"}Verifică-le cu atenție si incearcă din nou!</Text>
            ) : null
            }

            {isLoading ? 
            ( 
              <ActivityIndicator size="large" color="#628914" style={{ top: 80, alignSelf: 'center', zIndex: 1, elevation: 1 }} />
            ) : (
            <TouchableOpacity
            style={styles.buttonPlay}
            onPress={() => {
                checkTextInput();
                }}
            >
            <Ionicons name="md-enter" size={24} color="#628914" />
            </TouchableOpacity>
              )
            }
            <TouchableOpacity
            style={styles.logoutBtn}
            onPress={
              () => {
                navigation.replace('Resetare Parola',
                {
                  useremail:email,
                  tokenKey:tokenKey, 
                });
              }
            }
            >
            <View  style={{flexDirection:"row"}}>
              <View style={{justifyContent: 'flex-start',}}>
              <Text>Am uitat parola! </Text>
              </View>
              <View style={{justifyContent: 'flex-end',}}>
              <Ionicons name="ios-mail-unread-outline" size={24} color="black" />
              </View>
            </View>
            </TouchableOpacity>
        </View>
        </ScrollView>
    )

}

const styles = StyleSheet.create({
    container: {
      flex: 1,
      justifyContent: 'center',
      backgroundColor: '#FFFFFF',
      width:"100%",
      height:"100%"
    },
    logo: {
      position: "absolute",
      alignSelf: 'flex-start',
      top: 30,
      left: 20,
      width: 300, 
      height: 99
    },
    h1: {
      fontSize: 16,
      alignContent: "flex-start",
      alignSelf: 'flex-start',
      left:20,
      right:20,
      padding:20,
      fontWeight: 'bold',
      color:"#3E473A",
      top:10,
  
    },
    h2: {
      fontSize: 16,
      alignContent: "flex-start",
      alignSelf: 'flex-start',
      left:20,
      color:"#628914",
      paddingTop:10,
    },
    MainText: {
      fontSize: 14,
      fontWeight: 'bold',
      color: "#3E473A",
      flexShrink: 1,
      top:40,
    },
    input: {
      height: 40,
      margin: 12,
      borderWidth: 1,
      padding: 10,
      top:40,
      borderWidth: 1,
      borderColor: '#777',
      padding: 8,
      margin: 10,
      width: 200,
      borderRadius:25,
    },
    inputMando: {
      top:40,
      color: 'red'
    },
    inputPassword1: {
      height: 40,
      margin: 12,
      borderWidth: 1,
      padding: 10,
      top:40,
      borderWidth: 1,
      borderColor: '#777',
      padding: 8,
      margin: 10,
      width: 200,
      borderRadius:25,
    },
    inputMandoPassword1: {
      top:40,
      color: 'red'
    },
    buttonPlay: {
      top:50,
      alignSelf: 'center',
      width: 50,
      height: 50,
      backgroundColor: '#EFEB88',
      borderRadius:25,
      justifyContent: 'center',
      alignItems: 'center',
      shadowColor: '#000',
      shadowOffset: {
        width:0,
        height:3,
      },
      shadowOpacity: 0.15,
      shadowRadius:6.46,
      elevation:9,
    },
    logoutBtn: {
      alignSelf: 'flex-end',
      // width: 50,
      height: 50,
      right:20,
      justifyContent: 'center',
      alignItems: 'center',
    },
  });
   